import { Injectable } from '@angular/core';
import { ServiceBase } from '@app/origami-api/services/base/service.base';

export interface PostNewDataRoomRequestOptions {
  integrationTaskType: number;
  siteId: number;
}

@Injectable()
export class IntegrationService extends ServiceBase {
  serviceUrl = 'IntegrationService.svc';

  postNewDataRoomRequest(body: PostNewDataRoomRequestOptions) {
    return this.origamiPost('/PostNewDataRoomRequest', body, null, null, true);
  }
}
